import React from 'react';
import moment from 'moment';
import { getDollarFormat } from 'utils/helpers';
import NoDataMsg from 'library/noData';

const Body = ({ productPriceChangeReport, endDate, beginDate }) => (
    <div>
        {
            productPriceChangeReport.length <= 0 ?
                //If there's NO DATA to display
                <NoDataMsg />
                :
                productPriceChangeReport.length > 0 &&
                //If there's DATA
                <div>

                    <div className="row m-0">
                        <div className="text-center list_header">
                            {beginDate ?
                                <p><i>From</i> <b>{moment(beginDate).format('MMMM Do, YYYY')}</b> <i> to </i>
                                    {endDate ? <b>{moment(endDate).format('MMMM Do, YYYY')}</b> : moment().format('MMMM Do, YYYY')}</p>
                                : ""}
                        </div>
                    </div>
                    <div className="table-responsive">
                        {
                            productPriceChangeReport.map((item, index) => {
                                return (
                                    <div className="row m-0 mb-2" key={index}>

                                        <div className="col-lg-12 title_th">
                                            <h3 className="m-0">{moment(item.createdDate).format('MMMM Do, YYYY')}</h3>
                                        </div>{/* row - Date */}

                                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-3 text-center border-right">
                                            <label>Product Name</label>
                                            <h3 className="m-0 purple-text">{item.productName}</h3>
                                            <label className>SKU</label>
                                            <h5 className="m-0 grey-text">{item.sku}</h5>
                                        </div> {/* Column Orders */}

                                        <div className="col-lg-7 col-md-7 col-sm-7 col-xs-7 text-center daily_cash">
                                            <br></br>
                                            <div className="row m-0">
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 col-md- m-0 p-0 m-0 p-0">
                                                    <label>Old Price</label>
                                                    <h3 className="m-0 purple-text">{getDollarFormat(item.oldValue)}</h3>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 col-md- m-0 p-0">
                                                    <label>New Price</label>
                                                    <h3 className="m-0 green-text">{getDollarFormat(item.newValue)}</h3>
                                                </div>
                                                <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4 col-md- m-0 p-0">
                                                    <label>Difference</label>
                                                    <h3 className="m-0 orange-text">{getDollarFormat(item.diff)}</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-2 col-md-2 col-sm-2 col-xs-2 text-center border-left">
                                            <br></br>
                                            <label>Changed by</label>
                                            <h4 className="m-0 purple-text">{item.employeeName}</h4>
                                            <br></br>
                                        </div>
                                    </div>
                                );
                            })
                        }

                    </div>
                </div>
        }
    </div>
);

export default Body;


